import { ORDER_STATUS_ID_REQUESTED } from 'utility/constants'
import { isSpecialRequestedOrder } from './specialStores'

// Read only the classification fields of requested orders. Keyset pagination
// avoids a fixed row limit; the main query still paginates and counts in SQL.
export async function getSpecialRequestedOrderIds (client: any): Promise<number[]> {
  const ids: number[] = []
  let after = -1
  while (true) {
    const { data, error } = await client.from('orders')
      .select('id, custom_marketplace_id, marketplace_id(id, original_url), items(url, custom_order_site, deleted)')
      .eq('status_id', ORDER_STATUS_ID_REQUESTED)
      .is('estimated_costs_status', null)
      .is('iva_status', null)
      .gt('id', after)
      .order('id', { ascending: true })
      .limit(500)
    if (error || !data) throw new Error('Requested order classification unavailable')
    if (data.length === 0) return ids
    for (const order of data) {
      if (isSpecialRequestedOrder(order)) ids.push(order.id)
    }
    const lastId = data[data.length - 1].id
    if (lastId <= after) throw new Error('Requested order classification did not advance')
    after = lastId
  }
}

export function specialOrderFilter (ids: number[], specials: boolean) {
  if (specials) return [{ field: 'id', operator: 'in', value: ids.length ? ids : [-1] }]
  return ids.length ? [{ field: 'id', operator: 'notin', value: ids }] : []
}
